import type { ClientPersonReference } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'react-native-paper';

import { useAppState } from '@/features/authorization/provider/useAppState';
import { GroupMemberMenu } from '@/features/groups/components/members/GroupMemberMenu';
import { ListItem } from '@/features/list/components/ListItem';
import { PersonAvatar } from '@/features/media/components/avatar/PersonAvatar';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { getPersonName } from '@/shared/utils/person';

type Props = {
  groupId: string;
  member: ClientPersonReference;
  memberIsAdmin?: boolean;
  currentUserIsMember?: boolean;
  currentUserIsAdmin?: boolean;
};

export const GroupMemberItem: FC<Props> = ({
  groupId,
  member,
  memberIsAdmin = false,
  currentUserIsMember = false,
  currentUserIsAdmin = false
}) => {
  const { t } = useTranslation(LocalizationNameSpace.GROUPS, {
    keyPrefix: 'components.groupMemberItem'
  });
  const [menuVisible, setMenuVisible] = useState(false);
  const { userId: ownUserId } = useAppState();
  const isSelf = ownUserId === member.id;

  return (
    <ListItem
      style={{ paddingRight: 16, paddingVertical: 2 }}
      key={member.id}
      icon={() => <PersonAvatar person={member} canOpenGallery />}
      title={isSelf ? t('you') : getPersonName(member)}
      badge={
        <GroupMemberMenu
          groupId={groupId}
          member={member}
          userIsAdmin={currentUserIsAdmin}
          userIsMember={currentUserIsMember}
          memberIsAdmin={memberIsAdmin}
          visible={menuVisible}
          onDismiss={() => setMenuVisible(false)}
          anchor={
            <Text variant="labelSmall">
              {memberIsAdmin ? t('admin') : '  '}
            </Text>
          }
        />
      }
      hideRightArrow
      onPress={
        isSelf || !(currentUserIsMember || currentUserIsAdmin)
          ? undefined
          : () => {
              setMenuVisible(true);
            }
      }
    />
  );
};
